{
  "zh-TW": {
    "models": {
      "name": "飛船",
      "model": {
        "metrics": {
          "base": "基礎",
          "crew": "船員",
          "info": "資訊",
          "levels": "等級",
          "speed": "速度"
        },
        "focus": "定位",
        "classification": "分類",
        "size": "尺寸",
        "beam": "寬度",
        "cargo": "貨物",
        "crew": "船員",
        "speed": "速度",
        "minCrew": "最少船員",
        "maxCrew": "最多船員",
        "scmSpeed": "SCM Speed",
        "maxSpeed": "最大速度",
        "scm": "SCM",
        "max": "最大",
        "groundMaxSpeed": "最大速度",
        "groundReverseSpeed": "倒退速度",
        "pitch": "Pitch",
        "yaw": "Yaw",
        "roll": "Roll",
        "price": "價格",
        "groundAcceleration": "加速",
        "groundDeceleration": "減速",
        "scmSpeedAcceleration": "零到 SCM",
        "scmSpeedDeceleration": "SCM 到零",
        "compare": {
          "groundMaxSpeed": "最大地面速度",
          "groundReverseSpeed": "地面倒退速度",
          "groundAcceleration": "地面加速",
          "groundDeceleration": "地面減速"
        },
        "quantumFuelTankSize": "量子燃料",
        "hydrogenFuelTankSize": "燃料",
        "pledgePrice": "質押價格",
        "height": "高度",
        "length": "長度",
        "mass": "質量",
        "manufacturer": "製造商",
        "hardpoints": "掛載點",
        "weapons": "武器",
        "equipment": "裝備",
        "variants": "變體",
        "productionStatus": "生產狀態",
        "propulsion": "推進",
        "modular": "模組化",
        "soldAt": "在哪裡出售?",
        "rentalAt": "在哪裡租賃?",
        "lastUpdatedAt": "最後更新時間?",
        "loaners": "借用船",
        "paints": "塗裝",
        "modules": "模組",
        "modulePackages": "模組套件",
        "upgrades": "升級套件",
        "brochure": "手冊",
        "onSale": "販售中",
        "salesPage": "銷售頁面",
        "addons": "模組與升級套件",
        "productionStatuses": {
          "notAvailable": "N/A",
          "ready": "機庫就緒",
          "announced": "已公佈"
        }
      }
    }
  }
}
